<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2d"><a id="page_4"></a>Contents</h2>
<p class="toc"><a href="#/xhtml/frontmatter1">Introduction</a></p>
<p class="toc"><a href="#/xhtml/section1">SECTION ONE: LET THE COWS COME HOME! FOOLPROOF SUBSTITUTIONS FOR DAIRY</a></p>
<p class="toc"><a href="#/xhtml/chapter1">Chapter 1 How To Substitute for DAIRY</a></p>
<p class="toc1"><a href="#/xhtml/chapter1#ch1sec1">Recipes</a></p>
<p class="toc"><span href="#/xhtml/chapter2" title="Link target outside of Sample">Chapter 2 How To Substitute for CHEESE</span></p>
<p class="toc1"><span href="#/xhtml/chapter2#ch2sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><span href="#/xhtml/section2" title="Link target outside of Sample">SECTION TWO: MAKE THE CHICKENS SMILE! FOOLPROOF SUBSTITUTIONS FOR EGGS</span></p>
<p class="toc"><span href="#/xhtml/chapter3" title="Link target outside of Sample">Chapter 3 How to Substitute for EGGS</span></p>
<p class="toc1"><span href="#/xhtml/chapter3#ch3sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><span href="#/xhtml/section3" title="Link target outside of Sample">SECTION THREE: KEEP THE FARM ANIMALS FLOURISHING! FOOLPROOF SUBSTITUTIONS FOR MEAT</span></p>
<p class="toc"><span href="#/xhtml/chapter4" title="Link target outside of Sample">Chapter 4 How to Substitute for BEEF, CHICKEN, PORK, and SEAFOOD</span></p>
<p class="toc1"><span href="#/xhtml/chapter4#ch4sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><a id="page_5"></a><span href="#/xhtml/section4" title="Link target outside of Sample">SECTION FOUR: LEAVE THE BEES TO BUZZ! FOOLPROOF SUBSTITUTIONS FOR ANIMAL BY-PRODUCTS</span></p>
<p class="toc"><span href="#/xhtml/chapter5" title="Link target outside of Sample">Chapter 5 How to Substitute for HONEY and GELATIN</span></p>
<p class="toc1"><span href="#/xhtml/chapter5#ch5sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><span href="#/xhtml/section5" title="Link target outside of Sample">SECTION FIVE: LET YOUR BODY REJOICE! FOOLPROOF SUBSTITUTIONS FOR GLUTEN, SOY, REFINED SUGAR, AND FAT</span></p>
<p class="toc"><span href="#/xhtml/chapter6" title="Link target outside of Sample">Chapter 6 How to Substitute for GLUTEN</span></p>
<p class="toc1"><span href="#/xhtml/chapter6#ch6sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><span href="#/xhtml/chapter7" title="Link target outside of Sample">Chapter 7 How to Substitute for Soy</span></p>
<p class="toc1"><span href="#/xhtml/chapter7#ch7sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><span href="#/xhtml/chapter8" title="Link target outside of Sample">Chapter 8 How to Substitute for REFINED SUGAR</span></p>
<p class="toc1"><span href="#/xhtml/chapter8#ch8sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><span href="#/xhtml/chapter9" title="Link target outside of Sample">Chapter 9 How to Substitute for FAT</span></p>
<p class="toc1"><span href="#/xhtml/chapter9#ch9sec1" title="Link target outside of Sample">Recipes</span></p>
<p class="toc"><span href="#/xhtml/section6" title="Link target outside of Sample">SECTION SIX: ENJOY KITCHEN SUCCESS! THE COMPLETE CHART OF VEGAN FOOD SUBSTITUTIONS</span></p>
<p class="toc"><span href="#/xhtml/backmatter1" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc2"><span href="#/xhtml/backmatter2" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc2"><span href="#/xhtml/backmatter3" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?532e2b7d